<template>   
	<v-container text-xs-center class="pa-0" fluid fill-height>
		<v-layout justify-center align-center>
			<v-flex xs12 class="black">        
				<transition name="jb-fade">					
					<vue-flux style="z-index:0;" v-if="backgroundSlides !='' && showFlux === true && toIqomah === false" 
					:options="fluxOptions"
					:images="backgroundSlides"
					:transitions="backgroundTransition" 
					:transitionOptions="fluxTransitionOptions"            
					></vue-flux> 
				</transition>
			</v-flex>
		</v-layout>
		
		<div class="topbar">
			<v-layout row wrap  >
				<v-flex xs3 text-xs-left class="cpt-2 cpl-2 font-weight-bold black-shadow1">
					<div class="mday blue--text text--lighten-5 pa-0 ma-0">{{ $moment().format('dddd') }},</div>
					<div class="mdatem blue--text text--lighten-4">{{ $moment().format('LL') }}<span class="masehi" >M</span></div>
					<v-divider class="blue lighten-5"></v-divider>
					
					<div v-if="storeSetting.arabic_hijri_calendar === true" class="mdateh-arb  blue--text text--lighten-3">
						{{ $moment().locale('ar-sa').format('dddd,') }}
						{{ hijriClock.locale('ar-sa').format('iDD  iMMM  iYYYY') }}
					</div>
					<div v-else class="mdateh-ind blue--text text--lighten-3 pa-0 ma-0">					
						{{ hijriClock.format('iDD') }}
						{{ $t(hijriClock.locale(storeSetting.locale).format('iMMMM')) }}
						{{ hijriClock.format('iYYYY') }}<span class="hijriah">H</span>	
					</div>

				</v-flex> 
				<v-flex xs6 class="cpt-1">
					<div @click="changeLicense()" :class="storeSetting.mos_font+' '+ storeSetting.color_mos_name + '--text mosname ma-0 black-shadow2'" v-html="storeSetting.mos_name"></div>
					<div class="font-weight-bold black-shadow2 moscon text-truncate white--text">
						<span class="mosaddress white--text" v-html="storeSetting.mos_address"></span>&nbsp;
						<span class="mosphone yellow--text text--lighten-3" v-if="storeSetting.mos_contact" v-html="storeSetting.mos_contact"></span>
					</div>
				</v-flex>
				<v-flex xs3 text-xs-right class="cpr-2">
					<div :class="((storeSetting.lcd_font === true) ? 'clockled' : 'clock') +' '+ storeSetting.color_clock +'--text pa-0 ma-0 black-shadow1' ">{{ $moment().format("HH:mm:ss") }}</div>
				</v-flex>
			</v-layout> 
		</div>

		<div class="bottombar">
			<v-layout row wrap class="cpx-05">

				<v-flex xs5>
					<div class="greyopc display-timer white-shadow1 font-weight-bold" v-if="nextPraytime && generatedTimer && storeSetting.show_next_schedule === true">
						<span class="display-timer-arb" v-if="storeSetting.arabic_next_schedule == 1">
							{{ nextPraytime.ar_name }}
						</span>
						<span v-else class="display-timer-ind green--text text--darken-4">{{ $t(nextPraytime.name) }}</span>
						<span :class="((storeSetting.lcd_font === true) ? 'display-timer-counter-led' : 'display-timer-counter')">
							- {{ ('000' + generatedTimer.toward.hours).slice(-2) }}:{{ ('000'+ generatedTimer.toward.minutes).slice(-2) }}:{{ ('000'+ generatedTimer.toward.seconds).slice(-2) }}
						</span>						
					</div>
				</v-flex>
				
				<v-flex xs5 offset-xs2 v-if="storeSetting.show_next_holiday === true">
					<div class="greyopc display-holiday white-shadow1 font-weight-bold" v-if="nextHoliday">
						<div v-if="hijriClock.diff(prevHoliday.masehiFromHijri, 'minutes') <= 1440">
							<span class="holiday-count " >{{ $t('today') }} </span>
							<span class="holiday-name green--text text--darken-4" >{{  $t(prevHoliday.name) }}</span>
						</div>
						
						<div v-else>
							<span class="holiday-name green--text text--darken-4" >{{ $t(nextHoliday.name) }}</span>
							<span class="holiday-count" > {{ remainingHoliday }}</span>							
						</div>
					</div>
				</v-flex>			
			</v-layout>          

			<v-layout row wrap class="blackopc" v-if="filteredPraytimes">
				<v-flex xs2 text-xs-center class="cpx-05" v-for="(item, i) in filteredPraytimes" :key="i">
					<v-card :class="'cmy-1 ' + color[i]" >
						<div class="sc_name_arb yellow--text black_shadow2 font-weight-bold" v-if="storeSetting.arabic_sc_name == 1">{{ item.ar_name }}</div>
						<div v-else class="sc_name yellow--text black_shadow2 font-weight-bold">{{ $t(item.name) }}</div>
						<div :class="((storeSetting.lcd_font === true) ? 'sc_time-led' : 'sc_time') + ' white--text font-weight-medium black_shadow2'">
							{{ $moment(item.time).format('HH:mm') }}
						</div>
					</v-card>
				</v-flex>           
			</v-layout>          

			<v-layout class="black">
				<v-flex xs12>
					<v-card :class="'ticker-container ' + storeSetting.ticker_bgcolor">
						
						<swiper :options="swiperOption" ref="mySwiper" class="swiper" style="z-index:0;" v-if="showTicker === true && storeSetting.ticker_transition != 'running_text'">
							<swiper-slide 
							v-for="ticker in tickers"
							class="ticker"
							:key="ticker.id"
							><div :style="'color:' + storeSetting.ticker_textcolor ">{{ ticker.text }}</div>
							</swiper-slide>							
						</swiper>

						<VTextMarquee v-if="showTicker === true && storeSetting.ticker_transition == 'running_text'" class="running-text" :style="'color:' + storeSetting.ticker_textcolor " :speed="75">
								<slot>
									<span v-html="marqueeList"></span>
								</slot>
						</VTextMarquee>

					</v-card>
				</v-flex>
			</v-layout>          			
		</div>

	</v-container>
</template>

<script >
	import { VueFlux, Transitions } from 'vue-flux';
	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	import { VTextMarquee } from 'vue-text-marquee';	
	import { mapState, mapGetters  } from 'vuex'	
	import Swal from 'sweetalert2'

	export default{
		components: { VueFlux, swiper, swiperSlide, VTextMarquee },
		props:['tickers', 'marqueeList', 'backgrounds'],

		data(){
			return{
				
				showFlux: false,
				showTicker: false,
				fluxOptions: {},
				swiperOption: {},
				color:['tealopc', 'redopc', 'orangeopc', 'greenopc', 'purpleopc',' blueopc', 'greyopc'],                
				backgroundTransition:{},
				fluxTransitionOptions:{
					transitionWaterfall:{ tileDuration:1800,tileDelay: 240 },
					transitionFade: { totalDuration: 2000 },
					transitionSwipe: { totalDuration: 2000 },
					transitionBlocks1: { tileDuration: 600, tileDelay: 2000 },
					transitionSlide: { totalDuration: 2000 },
					transitionKenburn: { totalDuration: 3000 },
					transitionZip: { tileDuration: 1800, tileDelay: 240 },
					transitionBlinds2d: { tileDuration: 1600, tileDelay:200 },
					transitionCamera: { tileDuration: 2000, tileDelay: 400 },
					// transitionWarp: { tileDuration: 1600,tileDelay: 200 },
					transitionRound2: { tileDuration: 1600, tileDelay:200 },
					transitionBlocks2: { tileDuration: 2000, tileDelay:200 },          
					transitionExplode: { tileDuration: 2000, tileDelay:200 }
				},
			}
		},

		created(){ 
			this.setFlux()
			this.setTicker()
		},

		// mounted(){
		// 	setTimeout(()=>{
		// 		this.showFlux = true
  //       this.showTicker = true
  //     }, 2000)
		// },		

		computed:{
			backgroundSlides(){
				if(this.backgrounds.length == 0 ) return []
					return this.backgrounds.map(item => this.server+'/static/images/backgrounds/'+ this.storeSetting.UserId + '/'+item.image)
			},			

			marqueeHeight(){
				return (window.innerHeight / 13.5)
			},

			filteredPraytimes(){        
				let fp = this.todayPraytime.filter(item => {						
					var excluded = (this.storeSetting.additional_praytime == "imsyak") ? "syuruq" : "imsyak"
					// return item.slug != 'isya0' && item.slug != 'shubuh1' && item.slug != excluded
					return this.$moment(item.time).format('DD') == this.$moment().format('DD') && item.slug != excluded
				})
				return fp
			},	

			remainingHoliday(){ 
        if (!this.nextHoliday) return 999        
        var hol = this.$moment(this.nextHoliday.masehiFromHijri).format('YYYY-MM-DD HH:mm')
				var now = this.hijriClock

        return this.$moment(hol).from(this.$moment(now))
      },

			...mapState({
         storeSetting: state => state.setting,
         clock: state => state.clock, 
         hijriClock: state => state.hijriClock, 
         server: state => state.server,
         todayPraytime: state => state.todayPraytime,
         hijriTurnOver: state => state.hijriTurnOver
      }),

      ...mapGetters([
        'nextPraytime', 'prevPraytime', 'toIqomah', 'generatedTimer', 'nextHoliday', 'prevHoliday'
      ])				

		},

		methods:{
			setTicker(){
				this.swiperOption = {
					effect: this.storeSetting.ticker_transition.split('_')[0],
					autoHeight: true,
					direction: this.storeSetting.ticker_transition.split('_')[1],
					speed:1500,
					loop:true,
					autoplay:{            
						delay: this.storeSetting.ticker_duration * 1000
					}					
				}
			},

			setFlux(){
				this.fluxOptions = { autoplay: true, delay: this.storeSetting.carousel_duration * 1000}        

				if (this.storeSetting.background_transition == 'slide'){
					this.backgroundTransition = { transitionSlide: Transitions.transitionSlide }
				} else if (this.storeSetting.background_transition == 'all'){
					this.backgroundTransition = {
						transitionWaterfall: Transitions.transitionWaterfall,
						transitionFade: Transitions.transitionFade,
						transitionSwipe: Transitions.transitionSwipe,
						transitionBlocks1: Transitions.transitionBlocks1,
						transitionSlide: Transitions.transitionSlide,
						transitionKenburn: Transitions.transitionKenburn,
						transitionZip: Transitions.transitionZip,
						transitionBlinds2d: Transitions.transitionBlinds2d,
						transitionCamera: Transitions.transitionCamera,
						// transitionWarp: Transitions.transitionWarp,
						transitionRound2: Transitions.transitionRound2,
						transitionBlocks2: Transitions.transitionBlocks2,
						transitionExplode: Transitions.transitionExplode
					}
				} else if (this.storeSetting.background_transition == 'fade'){
					this.backgroundTransition = { transitionFade: Transitions.transitionFade }
				}

			},  

			changeLicense(){
				Swal.fire( {
					title: this.$i18n.t('attention'), 					
					html: this.$i18n.t('current_license', {lic: this.storeSetting.license} ),
					type: 'warning', 		
					showCancelButton: true,
					confirmButtonText: this.$i18n.t('next') 
				})				
				.then(res=>{
					if(res.value){
						localStorage.removeItem('UserId')
						localStorage.removeItem('license')
						this.$router.push('/wait')
					}
				})
			}    
		}
	}
</script>

<style scoped>

	.topbar{position: absolute;top:0;background: rgba(0,0,0,0.5);width: 100%;}
	.bottombar{position: absolute;bottom:0; width: 100%; }

	@media all and (orientation:portrait) {
		.mday{ font-size: 2.8125vw; line-height:2.8125vw;}
		.mdatem{ font-size: 2.390625vw; line-height:2.8125vw;}
		.mdateh-ind{ font-size: 2.19375vw; line-height:2.8125vw;}	
		.mdateh-arb {  font-family: 'Uthmanic';font-size: 2.25vw; line-height:2.8125vw;margin-top: 0.5625vw;} /*top date*/
		.hijriah {font-size:1.6875vw;color:#eee;}
		.masehi {font-size:1.6875vw;color:#eee;}

		.moscon { line-height: 1.77778vw !important; }
		.mosaddress {font-size:1.96875vw; line-height: 2.671875vw ;}
		.mosphone {font-size:1.96875vw; line-height: 2.671875vw ;}
		.clock{ font-size: 5.625vw;line-height:10.96875vw;font-weight: bold;}
		.clockled { font-family: Led; font-size: 5.90625vw; line-height: 10.96875vw;}

		.display-timer{height:5.0625vw;line-height: 5.0625vw;}
		.display-timer-arb{ font-family: 'Uthmanic'; font-size:3.9375vw } /*nextPraytime*/
		.display-timer-ind{font-size: 3.09375vw;}
		.display-timer-counter{font-size: 3.375vw;}
		.display-timer-counter-led{font-family:led; font-size: 3.9375vw; line-height:5.0625vw;}

		.sc_time-led{font-family:led; font-size:6.1875vw;line-height:5.0625vw;}
		.sc_name{font-size:2.8125vw;line-height:3.375vw;}
		.sc_name_arb{ font-family: 'Uthmanic'; font-size: 3.65625vw;line-height:3.375vw;padding-top:0.28125vw;} /*sholat-name*/
		.sc_time{font-size:5.0625vw;line-height:5.0625vw;}

		.display-holiday{height:5.0625vw;line-height:5.0625vw;}
		.holiday-name{font-size: 3.09375vw;}
		.holiday-count{font-size: 2.8125vw;}
		
		.oleo.mosname{ font-family: "Oleo Script"; font-size: 3.9375vw; line-height: 4.5vw;font-weight: 500;}
		.aladin.mosname{ font-family: Aladin; font-size: 4.5vw; line-height: 4.5vw;}
		.eczar.mosname{ font-family: 'Eczar'; font-size: 4.21875vw; line-height: 4.5vw;font-weight: 500;}
		.roboto.mosname{ font-family: Roboto; font-size: 3.9375vw; line-height: 4.5vw;font-weight: 700;}
		.led.mosname{ font-family: Led; font-size: 4.21875vw; line-height: 2.53125vw;}

		.ticker-container {height: 4.5vw;}
		.swiper {height: 4.5vw;}
		.ticker{ white-space: nowrap; overflow: hidden;font-size:3.0375vw;line-height:4.5vw;}
		.running-text { font-size:3.0375vw;line-height:4.5vw;}
	}

	@media all and (orientation:landscape) {
		.mday{ font-size: 5vh; line-height:5vh;}
		.mdatem{ font-size: 4.25vh; line-height:5vh;}
		.mdateh-ind{ font-size: 3.9vh; line-height:5vh;}	
		.mdateh-arb {  font-family: 'Uthmanic';font-size: 4vh; line-height:5vh;margin-top: 1vh;} /*top date*/
		.hijriah {font-size:3vh;color:#eee;}
		.masehi {font-size:3vh;color:#eee;}

		.moscon { line-height: 1vh !important; }	
		.mosaddress {font-size:3.5vh; line-height: 4.75vh ;}
		.mosphone {font-size:3.5vh; line-height: 4.75vh ;}
		.clock{ font-size: 10vh;line-height:19.5vh;font-weight: bold;}
		.clockled { font-family: Led; font-size: 10.5vh; line-height: 19.5vh;}

		.display-timer{height:9vh;line-height:9vh;}
		.display-timer-arb{ font-family: 'Uthmanic'; font-size:7vh } /*nextPraytime*/
		.display-timer-ind{font-size: 5.5vh;}
		.display-timer-counter{font-size: 6vh;}
		.display-timer-counter-led{font-family:led; font-size: 7vh; line-height: 9vh;}

		.sc_time-led{font-family:led; font-size:10vh;line-height:9vh;}
		.sc_name{font-size:5vh;line-height:6vh;}
		.sc_name_arb{ font-family: 'Uthmanic'; font-size: 6vh;line-height:6vh;padding-top:0.5vh;} /*sholat-name*/
		.sc_time{font-size:9vh;line-height:9vh;}

		.display-holiday{height:9vh; line-height:9vh;}
		.holiday-name{font-size: 5.5vh;}
		.holiday-count{font-size: 5vh;}

		.oleo.mosname{ font-family: "Oleo Script"; font-size: 7vh; line-height: 8vh;font-weight: 500;}
		.aladin.mosname{ font-family: Aladin; font-size: 8vh; line-height: 8vh;}
		.eczar.mosname{ font-family: 'Eczar'; font-size: 7.5vh; line-height: 8vh;font-weight: 500;}
		.roboto.mosname{ font-family: Roboto; font-size: 7vh; line-height: 8vh;font-weight: 700;}
		.led.mosname{ font-family: Led; font-size: 7.5vh; line-height: 8vh;}

		.ticker-container {height: 8vh;}
		.swiper {height: 8vh;}
		.ticker{ white-space: nowrap; overflow: hidden;font-size:5.4vh;line-height:8vh;}
		.running-text { font-size:5.4vh;line-height:8vh;}	
	}

</style>